import { useState } from 'react';
import { Layout as AntLayout, Menu, Button, Dropdown, Avatar } from 'antd';
import {
  DashboardOutlined,
  TeamOutlined,
  CloudServerOutlined,
  DatabaseOutlined,
  UserOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  RocketOutlined,
  DownloadOutlined,
  KeyOutlined,
  FileTextOutlined,
  ShopOutlined,
  NotificationOutlined,
} from '@ant-design/icons';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { Breadcrumbs } from './Breadcrumbs';
import { useKeyboardShortcuts } from '../hooks/useKeyboardShortcuts';
import { KeyboardShortcutsHelp } from './KeyboardShortcutsHelp';

const { Header, Sider, Content } = AntLayout;

export function Layout() {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuthStore();
  const { isHelpOpen, setIsHelpOpen } = useKeyboardShortcuts();

  // Get selected key - handle sub-routes like /firms/123
  const getSelectedKey = () => {
    const path = location.pathname;
    if (path.startsWith('/firms/')) return '/firms';
    return path;
  };

  const menuItems = [
    {
      key: '/',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
    },
    {
      key: '/firms',
      icon: <TeamOutlined />,
      label: 'Firmalar',
    },
    {
      key: '/dealers',
      icon: <ShopOutlined />,
      label: 'Bayiler',
    },
    {
      key: '/users',
      icon: <UserOutlined />,
      label: 'Kullanıcılar',
    },
    {
      key: '/announcements',
      icon: <NotificationOutlined />,
      label: 'Duyurular',
    },
    {
      type: 'divider' as const,
    },
    {
      key: '/agents',
      icon: <CloudServerOutlined />,
      label: 'Agentlar',
    },
    {
      key: '/agent-versions',
      icon: <RocketOutlined />,
      label: 'Agent Versiyonları',
    },
    {
      key: '/agent-downloads',
      icon: <DownloadOutlined />,
      label: 'Agent İndirmeleri',
    },
    {
      key: '/sources',
      icon: <DatabaseOutlined />,
      label: 'Veri Kaynakları',
    },
    {
      key: '/api-keys',
      icon: <KeyOutlined />,
      label: 'API Keys',
    },
    {
      key: '/logs',
      icon: <FileTextOutlined />,
      label: 'Loglar',
    },
  ];

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: user?.name || 'Kullanıcı',
    },
    {
      type: 'divider' as const,
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Çıkış Yap',
      onClick: handleLogout,
    },
  ];

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div style={{
          height: 64,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontSize: collapsed ? 16 : 20,
          fontWeight: 'bold',
        }}>
          {collapsed ? 'RG' : 'RaporGör'}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[getSelectedKey()]}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
        />
      </Sider>

      <AntLayout>
        <Header style={{
          padding: '0 16px',
          background: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
          />

          <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
            <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}>
              <Avatar icon={<UserOutlined />} />
              <span>{user?.name}</span>
            </div>
          </Dropdown>
        </Header>

        <Content style={{
          margin: 24,
          padding: 24,
          background: '#fff',
          borderRadius: 8,
          minHeight: 280,
        }}>
          <Breadcrumbs />
          <Outlet />
        </Content>
      </AntLayout>

      <KeyboardShortcutsHelp open={isHelpOpen} onClose={() => setIsHelpOpen(false)} />
    </AntLayout>
  );
}
